/* signup-source.js (Claude 2026-10-16, Kei: "go")
   Where did a newsletter signup come from? Records the visitor's first and last "touch" (UTMs, Facebook /
   Google / Microsoft click ids, an outside referrer, the landing page) in localStorage. When the visitor then
   subscribes to a Klaviyo list, through a Klaviyo popup (klaviyoForms event) or any theme form that posts to
   a.klaviyo.com/client/subscriptions, it sends ONE "Signup Source" event to Klaviyo and writes signup_* profile
   properties. It never writes $source (flows and the theme forms use that one).
   Read by temp/_lib/leadsweep-signup-sources.js for the daily Lead Sweep. Same file on JPCo, Coffee, DOJ, Wine. */
(function () {
  if (window.DJSignupSource) return;

  var KEY = 'dj_signup_touch_v1';
  var SENT_KEY = 'dj_signup_sent_v1';
  var COMPANY_ID = 'UcWqjv';
  var REVISION = '2024-02-15';
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'msclkid'];
  var nativeFetch = window.fetch;
  var pending = {};

  function declined() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var consent = privacy && privacy.currentVisitorConsent && privacy.currentVisitorConsent();
      return !!consent && (consent.analytics === 'no' || consent.marketing === 'no');
    } catch (e) {
      return false;
    }
  }

  function read(key, store) {
    try { return JSON.parse((store || window.localStorage).getItem(key) || 'null'); } catch (e) { return null; }
  }

  function write(key, value, store) {
    try { (store || window.localStorage).setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function clip(value, max) {
    return String(value == null ? '' : value).slice(0, max || 200);
  }

  function hostOf(url) {
    try { return new URL(url).hostname.replace(/^www\./, ''); } catch (e) { return ''; }
  }

  function captureTouch() {
    if (declined()) return;
    var query;
    try { query = new URLSearchParams(window.location.search); } catch (e) { return; }

    var touch = {};
    var hasSource = false;
    PARAMS.forEach(function (name) {
      var value = query.get(name);
      if (value) { touch[name] = clip(value, 200); hasSource = true; }
    });

    var referrer = document.referrer || '';
    var refHost = hostOf(referrer);
    var ownHost = window.location.hostname.replace(/^www\./, '');
    if (refHost && refHost !== ownHost && !/(^|\.)(shopify\.com|shop\.app)$/.test(refHost)) {
      touch.referrer = clip(referrer, 300);
      hasSource = true;
    }

    var saved = read(KEY) || {};
    if (!hasSource && saved.first) return;

    touch.page = clip(window.location.origin + window.location.pathname, 300);
    touch.at = new Date().toISOString();
    if (!saved.first) saved.first = touch;
    if (hasSource) saved.last = touch;
    write(KEY, saved);
  }

  function describe(prefix, touch, props) {
    if (!touch) return;
    props[prefix + 'source'] = touch.utm_source
      || (touch.fbclid ? 'facebook (click id)' : '')
      || (touch.gclid ? 'google ads (click id)' : '')
      || (touch.msclkid ? 'microsoft ads (click id)' : '')
      || (touch.referrer ? hostOf(touch.referrer) : '')
      || 'direct';
    ['utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'msclkid', 'referrer'].forEach(function (name) {
      if (touch[name]) props[prefix + name.replace(/^utm_/, '')] = touch[name];
    });
    props[prefix + 'landing_page'] = touch.page;
    props[prefix + 'at'] = touch.at;
  }

  function flush(email) {
    var signup = pending[email];
    if (!signup) return;
    delete pending[email];

    var sent = read(SENT_KEY, window.sessionStorage) || {};
    if (sent[email] && Date.now() - sent[email] < 30 * 60 * 1000) return;
    sent[email] = Date.now();
    write(SENT_KEY, sent, window.sessionStorage);

    var saved = read(KEY) || {};
    var props = {
      signup_site: window.location.hostname.replace(/^www\./, ''),
      signup_page: clip(window.location.origin + window.location.pathname, 300),
      signup_form: clip(signup.forms.join(' | '), 200),
      signup_at: new Date().toISOString()
    };
    describe('signup_first_', saved.first, props);
    describe('signup_last_', saved.last || saved.first, props);

    var eventProps = { list_ids: signup.lists };
    Object.keys(props).forEach(function (name) { eventProps[name] = props[name]; });

    var body = {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: 'Signup Source' } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } },
          properties: eventProps,
          unique_id: email + '|' + props.signup_at
        }
      }
    };

    try {
      nativeFetch.call(window, 'https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(signup.company), {
        method: 'POST',
        keepalive: true,
        headers: { revision: REVISION, 'content-type': 'application/json' },
        body: JSON.stringify(body)
      }).catch(function () {});
    } catch (e) {}
  }

  function noteSignup(email, info) {
    if (!email || declined()) return;
    email = String(email).trim().toLowerCase();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return;

    var signup = pending[email];
    if (!signup) {
      signup = pending[email] = { lists: [], forms: [], company: info.company || COMPANY_ID };
      setTimeout(function () { flush(email); }, 1500);
    }
    if (info.list && signup.lists.indexOf(info.list) < 0) signup.lists.push(info.list);
    if (info.form && signup.forms.indexOf(info.form) < 0) signup.forms.push(info.form);
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var result = nativeFetch.apply(window, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
        if (url.indexOf('a.klaviyo.com/client/subscriptions') > -1 && init && typeof init.body === 'string') {
          var data = (JSON.parse(init.body) || {}).data || {};
          var attributes = data.attributes || {};
          var profile = (attributes.profile && attributes.profile.data && attributes.profile.data.attributes) || {};
          var list = data.relationships && data.relationships.list && data.relationships.list.data;
          var company = url.match(/company_id=([A-Za-z0-9]+)/);
          var form = attributes.custom_source ? String(attributes.custom_source).split(':')[0] : 'theme form';
          result.then(function (response) {
            if (response && response.ok) {
              noteSignup(profile.email, { list: list && list.id, form: form, company: company && company[1] });
            }
          }, function () {});
        }
      } catch (e) {}
      return result;
    };
  }

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event && event.detail;
    if (!detail || (detail.type !== 'submit' && detail.type !== 'stepSubmit')) return;
    var meta = detail.metaData || {};
    if (meta.$email) noteSignup(meta.$email, { form: 'Klaviyo popup ' + (detail.formId || '') });
  });

  window.addEventListener('pagehide', function () {
    Object.keys(pending).forEach(flush);
  });

  captureTouch();
  window.DJSignupSource = { version: 1, touch: function () { return read(KEY); } };
})();
